import type { RootState } from '@/shared';

export const selectTxModal = (state: RootState) => state.txModal;
export const selectTxIsOpen = (state: RootState) => state.txModal.isOpen;
export const selectTxStatus = (state: RootState) => state.txModal.status;
